import { QRCode } from 'antd'

import { ComponentController } from './component_controller'

export class QRCodeController extends ComponentController {
  static values = { value: String }

  declare valueValue: string

  get component() {
    return QRCode
  }
}
